import React, {useEffect} from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { connect } from "react-redux"
import { addProfile } from "store/actions/profile"
import GlobalStateProvider from "context/provider"
import Layout from "components/layout"
import HomeLayout from "components/homelayout"

import SEO from "components/seo"
import Drop from "components/sections/drop"
import Specializations from 'components/sections/specializations';
import Solutions from 'components/sections/solutions';
import Commitments from 'components/sections/commitments';
import Contact from 'components/sections/contact';

import Footer from 'components/sections/footer';



import { siteTitle } from "config"
import { isSSR } from "utils/"

const IndexPage = ({ data, addProfile, profile }) => {
  const { frontmatter } = data.index.edges[0].node
  const { useSplashScreen } = frontmatter
  useEffect(() => {
    if (!isSSR) {
      const version =  window.localStorage.getItem('version');
      if(version !== "2.0.1") {
        window.localStorage.clear()
        window.localStorage.setItem('version', "2.0.1")
      }
      setTimeout(() => {
        window.analytics && window.analytics.page();
       }, 100)
    }
  }, [])
  const globalState = {
    // if useSplashScreen=false, we skip the intro by setting isIntroDone=true
    isIntroDone: useSplashScreen ? false : true,
    // darkMode is initially disabled, a hook inside the Layout component
    // will check the user's preferences and switch to dark mode if needed
    darkMode: true,
  }
  return (
    <GlobalStateProvider initialState={globalState}>
      <Layout home lang={"en"}>
        <SEO
          title={`${siteTitle} | Accueil`}
        />
        <Drop
          content={data.drop.edges}
          addProfile={addProfile}
          profile={profile}
          lang={"en"}
        />
      </Layout>
      <HomeLayout lang={"en"}>
        <Specializations
          content={data.specializations.edges}
        />
         <Solutions
          content={data.solutions.edges}
        />
        <Commitments
          content={data.commitments.edges}
        />
        <Contact content={data.contact.edges} />
         <Footer
          content={data.footer.edges}
        /> 
      </HomeLayout>
    </GlobalStateProvider>
  )
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  profile: state.profile.profile,
})

export default connect(mapStateToProps, { addProfile })(IndexPage)

export const pageQuery = graphql`
  {
    index: allMdx(filter: { fileAbsolutePath: { regex: "/index/index/" } }) {
      edges {
        node {
          frontmatter {
            seoTitle
            useSeoTitleSuffix
            useSplashScreen
          }
        }
      }
    }
    drop: allMdx(filter: { fileAbsolutePath: { regex: "/index/drop/drop/" } }) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            subtitlePrefix
          }
        }
      }
    }
    specializations: allMdx(filter: { fileAbsolutePath: { regex: "/index/specializations/specializations/" } }) {
      edges {
        node {
          body
          frontmatter {
            buttonText
          }
          exports {
            items {
              title
              category
              link
              image {
                childImageSharp {
                  gatsbyImageData(quality: 90)
                }
              
              }
            }
          }
        }
      }
    }
    solutions: allMdx(filter: { fileAbsolutePath: { regex: "/index/solutions/solutions/" } }) {
      edges {
        node {
          body
          exports {
            items {
              title
              description
              image {
                childImageSharp {
                  gatsbyImageData(width: 50, layout: FIXED, quality: 90)
                }
              
              }
            }
          }
        }
      }
    }
    commitments: allMdx(filter: { fileAbsolutePath: { regex: "/index/commitments/commitments/" } }) {
      edges {
        node {
          body
          exports {
            items {
              title
              description
              image {
                childImageSharp {
                  gatsbyImageData(width: 50, layout: FIXED, quality: 90)
                }
              
              }
            }
          }
        }
      }
    }
    footer: allMdx(filter: { fileAbsolutePath: { regex: "/index/footer/footer/" } }) {
      edges {
        node {
          body
        }
      }
    }
    contact: allMdx(filter: { fileAbsolutePath: { regex: "/index/contact/contact/" } }) {
      edges {
        node {
          body
          frontmatter {
            title
          }
        }
      }
    }
  }
`
